import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of, tap } from 'rxjs';

// Interface to represent the expected location data structure
export interface LocationInfo {
    status: string;
    country?: string;
    countryCode?: string;
    region?: string;
    regionName?: string;
    city?: string;
    zip?: string;
    lat?: number;
    lon?: number;
    timezone?: string;
    isp?: string;
    org?: string;
    as?: string;
    query?: string; // This will be the user's IP address
    message?: string; // For error status
}

@Injectable({
    providedIn: 'root',
})
export class LocationService {
    // Using ip-api.com - free, no API key needed for basic use
    private readonly apiUrl = 'http://ip-api.com/json'; // HTTPS often preferred: https://ip-api.com/json but http works too

    constructor(private readonly http: HttpClient) {}

    getUserLocation(): Observable<LocationInfo | null> {
        return this.http.get<LocationInfo>(this.apiUrl).pipe(
            tap((response) => console.log('Location API Response:', response)), // Optional: Log response
            catchError((error) => {
                return of(null);
            })
        );
    }
}
